export default __webpack_public_path__ + "static/media/Alekseeva_Zhanna_Vladimirovna.c1179624.webp";